import { useState, useEffect, useRef } from "react";
import "react-responsive-modal/styles.css";
import Link from "../../../MainComponents/Link";
import Profile_1 from "../../../Assets/04_Add_nominee.svg";
import Button from "react-bootstrap/Button";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import * as constClass from "../../../../constants";

import { Container, Form, Row, Col, FormGroup, FormControl } from "react-bootstrap";
import { DMF_BASE_URL } from "../../../../constants";
import axios from "axios";
import OTPInput, { ResendOTP } from "otp-input-react";
import commonEncode from "../../../../commonEncode";
import ProgressBar from "@ramonak/react-progress-bar";

import { SegmentedControl } from "segmented-control";
import Back from "../../../Assets/left-arrow.png";
import "../Fatca/style.css";
import FintooButton from "../../../HTML/FintooButton";
import FintooProfileBack from "../../../HTML/FintooProfileBack";
import { FaTrashAlt, FaEdit, FaMinusCircle } from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import moment from "moment/moment";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import WhiteOverlay from "../../../../components/HTML/WhiteOverlay";
import {
  CheckSession,
  apiCall,
  successAlert,
  errorAlert,
  loginRedirectGuest,
  getUserId,
  fetchEncryptData,
  fetchData,
} from "../../../../common_utilities";
import { Next } from "react-bootstrap/esm/PageItem";
import FintooDatePicker from "../../../HTML/FintooDatePicker";
import ImageUploader from "react-images-upload";

function NomineeDetails(props) {
  const [countryStateCity, setSountryStateCity] = useState({
    countries: [],
    states: [],
    cities: []
  });

  useEffect(() => {
    console.log('countryStateCity11', countryStateCity);
  }, [countryStateCity])

  const [validated, setValidated] = useState(false);
  const [totalAdded, setTotalAdded] = useState(0);
  const [addMore, setAddMore] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editNumber, setEditNumber] = useState(null);
  const [wantToAddNominee, setWantToAddNominee] = useState("no");
  const [allNominee, setAllNominee] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [fullname, setFullname] = useState("");
  const [percentage, setPercentage] = useState("");
  const [relation, setRelation] = useState("");
  const [dob, setDob] = useState("");
  const [guardianName, setGuardianName] = useState("");
  const [nominee_email, setNominee_email] = useState("");
  const [nominee_mobile, setNominee_mobile] = useState("");
  const [nominee_address1, setNominee_address1] = useState("");
  const [nominee_address2, setNominee_address2] = useState("");
  const [nominee_address3, setNominee_address3] = useState("");
  const [nominee_pincode, setNominee_pincode] = useState("");
  const [nominee_city, setNominee_city] = useState("");
  const [nominee_state, setNominee_state] = useState("");
  const [nominee_country, setNominee_country] = useState("");
  const [nominee_id_proof_type, setNominee_id_proof_type] = useState("");
  const [nominee_id_proof_number, setNominee_id_proof_number] = useState("");
  const [id_proof_image, setId_proof_image] = useState(null);


  const [error, setError] = useState({});
  const showBack = useSelector((state) => state.isBackVisible);
  const [dynamicNomineeList, getDynamicNomineeList] = useState([]);
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState("");
  const [pageload, setpage] = useState("");
  const [nomineeid, setnomineeid] = useState("");
  const [editThis, setEditThis] = useState({});
  const [updateSeg, setUpdateSeg] = useState(0);
  const [delnominee, setdelnominee] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  const [OTP, setOTP] = useState("");
  const [showdata, setShowdata] = useState(false);
  // const [show, setShow] = useState(false);
  const [mobile1, setmobile] = useState("")
  const [email1, setemail] = useState("")
  const [count, setCount] = useState(120);
  const [GeneratedSmsOTP, setGeneratedSmsOTP] = useState("");
  const [generatedemailotp, setGeneratedEmailOTP] = useState("");
  // const handleClose = () => setShow(false);
  const handleClosedata = () => setShowdata(false);
  const timer = useRef({ obj: null, counter: 120, default: 120 });
  const randomOTP = useRef(Math.floor(Math.random() * 90000) + 10000);
  const [nomineerelations, setNomineeRelations] = useState([]);
  const [uploaded_doc_image, setUploaded_doc_image] = useState("");

  const [navDynamic, setNavDynamic] = useState({ prev: "", next: "" });

  useEffect(() => {
    onLoadInIt();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    nomineelist();
    getNomineeRelations();
  }, [mobile1, email1]);

  const isDataSame = () => {

    console.log('id_proof_imageid_proof_image', id_proof_image)

    if (id_proof_image != null) return false;

    if (!allNominee[0]) return false;

    const proofType = allNominee[0] ? allNominee[0]["nominee_id_proof_type"] : '';

    let id_proof_type;
    if (proofType === "PAN") {
      id_proof_type = 1;
    } else if (proofType === "Aadhaar") {
      id_proof_type = 2;
    } else if (proofType === "Driving License") {
      id_proof_type = 3;
    } else {
      id_proof_type = "";
    }


    const currentNominee = {
      nominee_first_name: fullname,
      nominee_relation: relation,
      nominee_dob: moment(dob).format("YYYY-MM-DD"),
      nominee_email,
      nominee_mobile,
      nominee_address1,
      nominee_address2,
      nominee_address3,
      nominee_pincode,
      nominee_city,
      nominee_state,
      nominee_country,
      nominee_id_proof_type,
      nominee_id_proof_number,
      nominee_guardian_name: guardianName
    };

    const savedNominee = {
      nominee_first_name: allNominee[0].nominee_first_name,
      nominee_relation: allNominee[0].nominee_relation,
      nominee_dob: moment(allNominee[0].nominee_dob).format("YYYY-MM-DD"),
      nominee_email: allNominee[0].nominee_email,
      nominee_mobile: allNominee[0].nominee_mobile,
      nominee_address1: allNominee[0].nominee_address1,
      nominee_address2: allNominee[0].nominee_address2,
      nominee_address3: allNominee[0].nominee_address3,
      nominee_pincode: allNominee[0].nominee_pincode,
      nominee_city: allNominee[0].nominee_city,
      nominee_state: allNominee[0].nominee_state,
      nominee_country: allNominee[0].nominee_country,
      nominee_id_proof_type: id_proof_type,
      nominee_id_proof_number: allNominee[0].nominee_id_proof_number,
      nominee_guardian_name: allNominee[0].nominee_guardian_name ?? ""
    };

    console.log('currentNomineesavedNominee', currentNominee, savedNominee)

    return JSON.stringify(currentNominee) === JSON.stringify(savedNominee)
  }

  const handleNextBtn = () => {
    const sameCheck = isDataSame();
    console.log('isDataSame()', isDataSame())
    if (!sameCheck) {
      randomOTP.current = Math.floor(Math.random() * 90000) + 10000;
      startTimer();
      fetchMail();
      fetchSms();
      setShowdata(true);
    } else {
      props.onNext(navDynamic.next);
    }
  }

  const onLoadInIt = async () => {
    var data = { user_id: user_id };
    try {
      var data = commonEncode.encrypt(JSON.stringify(data));
      var config = {
        method: "post",
        url: DMF_BASE_URL + "api/user/getuserdetails",
        data: data,
      };
      var res = await axios(config);
      var response = commonEncode.decrypt(res.data);
      setUserDetails(JSON.parse(response)["data"]);
      setmobile(JSON.parse(response)["data"]['mobile'])
      setemail(JSON.parse(response)["data"]['email'])

    } catch (e) {
      dispatch({
        type: "RENDER_TOAST",
        payload: { message: "Something went Wrong...", type: "error" },
      });
    }
  };

  const startTimer = () => {
    setOTP("");
    // updatesetOTP("");
    clearInterval(timer.current.obj);
    timer.current.counter = timer.current.default;
    setCount(timer.current.counter);
    timer.current.obj = setInterval(() => {
      if (timer.current.counter == 0) {
        clearInterval(timer.current.obj);
        timer.current.counter = timer.current.default;
        return;
      }
      timer.current.counter = timer.current.counter - 1;
      setCount(timer.current.counter);
    }, 1000);
  };



  let navDynamicNext = "";
  let navDynamicPrev = "";
  if (userDetails.residential_status == "1") {
    navDynamicNext = "Bank";
    navDynamicPrev = "FatcaAll";
  } else if (
    userDetails.residential_status == "2" ||
    userDetails.residential_status == "3"
  ) {
    navDynamicNext = "Bank";
    navDynamicPrev = "FatcaAdd";
  }

  var user_id = getUserId();

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    props.onNext(navDynamicNext);
  };

  const [theArray, setTheArray] = useState([]);
  const addEntryClick = () => {
    if (theArray.length < 2)
      setTheArray([...theArray, `Entry ${theArray.length}`]);
  };

  const removeNominee = () => {
    let ta = theArray;
    ta.shift();
    setTheArray([...ta]);
  };
  const cancelForm = () => {
    setAddMore(false);
    setEditMode(false);
    setEditNumber(null);
  };

  const validateForm = () => {
    const tempEerror = {};
    if (fullname.trim() == "") tempEerror.fullname = "Name is required";
    if (fullname.length < 2 && fullname != "") tempEerror.fullname = "Please Provide Valid nominee first name "
    if (Boolean(dob) == false) tempEerror.dob = "Date of birth is required";
    if (guardianName.trim() == "" && moment().diff(moment(dob), "years") < 18 && guardianName.length < 2)
      tempEerror.guardianName = "Parent/Guardian name is required. ";
    if (relation.trim() == "") tempEerror.relation = "Relation is required";

    if (guardianName.trim() == "") {
      if (moment().diff(moment(dob), "years") < 18) {
        tempEerror.guardianName = "Parent/Guardian name is required.";
      } else {
        setGuardianName("");
      }
    } else if (!/^[a-z A-Z]+$/.test(guardianName)) { tempEerror.guardianName = "Please enter valid Parent/Guardian name"; }

    // ---------------------------------------------------------------------------------------------------------------------------------
    if (nominee_email.trim() === "") {
      tempEerror.nominee_email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(nominee_email)) {
      tempEerror.nominee_email = "Please enter a valid email address";
    }

    if (nominee_mobile === "") {
      tempEerror.nominee_mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(nominee_mobile)) {
      tempEerror.nominee_mobile = "Please enter a valid 10-digit mobile number";
    }

    if (nominee_address1.trim() === "")
      tempEerror.nominee_address1 = "Address line 1 is required";

    // if (nominee_address2.trim() === "")
    //   tempEerror.nominee_address2 = "Address line 2 is required";

    // if (nominee_address3.trim() === "")
    //   tempEerror.nominee_address3 = "Address line 3 is required";

    if (nominee_pincode.trim() === "")
      tempEerror.nominee_pincode = "Pincode is required";
    else if (!/^\d{5,6}$/.test(nominee_pincode))
      tempEerror.nominee_pincode = "Please enter a valid pincode";

    if (nominee_city === "")
      tempEerror.nominee_city = "City is required";

    if (nominee_state === "")
      tempEerror.nominee_state = "State is required";

    if (nominee_country === "")
      tempEerror.nominee_country = "Country is required";

    if (nominee_id_proof_type === "")
      tempEerror.nominee_id_proof_type = "ID proof type is required";

    if (nominee_id_proof_number === "") {
      tempEerror.nominee_id_proof_number = "ID proof number is required"
    } else {
      if (nominee_id_proof_type != "") {
        console.log('nominee_id_proof_type', nominee_id_proof_type)
        if (nominee_id_proof_type == "1" && !(/^[A-Z]{5}\d{4}[A-Z]$/.test(nominee_id_proof_number))) { tempEerror.nominee_id_proof_number = "Please enter a valid PAN" } else {
          if (userDetails.pan === nominee_id_proof_number) {
            tempEerror.nominee_id_proof_number = "PAN can not be same as parent"
          }
        }

        if (nominee_id_proof_type == "2" && !(/^[2-9]{1}[0-9]{11}$/.test(nominee_id_proof_number))) { tempEerror.nominee_id_proof_number = "Please enter a valid Aadhar number"; }
        if (nominee_id_proof_type == "3" && !(/^([A-Z]{2})(\d{2}|\d{3})[a-zA-Z]{0,1}(\d{4})(\d{7})$/.test(nominee_id_proof_number))) { tempEerror.nominee_id_proof_number = "Please enter a valid Driving License number"; }
      }
    }

    if (!id_proof_image) {
      if (!uploaded_doc_image) {
        tempEerror.id_proof_image = "Id proof image is required";
      }
    }
    console.log('tempEerrortempEerror', tempEerror)
    // ---------------------------------------------------------------------------------------------------------------------------------

    setError({ ...tempEerror });
    return !Boolean(Object.keys(tempEerror).length);
  };
  const editData = (v, index) => {
    setEditThis({
      nominee_first_name: v.nominee_first_name,
      nominee_dob: v.nominee_dob,
      nominee_guardian_name: v.nominee_guardian_name,
      nominee_relation: v.nominee_relation,
      percentage,
    });
    setEditNumber(index);
  };
  const saveData = (index) => {
    if (validateForm() == true) {
      addnomineedetails();
    }
  };
  const deleteData = (index) => {
    var old = allNominee;
    old.splice(index, 1);
    setAllNominee([...old]);
  };



  const resetForm = () => {
    setFullname("");
    setPercentage("");
    setDob("");
    setGuardianName("");;
    setRelation("");
    setEditNumber(null);
  };

  function refreshPage() {
    window.location.reload(true);
  }

  const nomineelist = async () => {
    var user_id = getUserId();
    try {
      var dynamicNomineeData = { user_id: user_id };
      var data = commonEncode.encrypt(JSON.stringify(dynamicNomineeData));
      var config = {
        method: "post",
        url: constClass.DMF_NOMINEELIST_API_URL,
        data: data,
      };
      var res = await axios(config);
      var response = commonEncode.decrypt(res.data);
      console.log('response >>>>>>>>>>>>>>>>>>>>>>>>>.. ', response)

      var allNominee = JSON.parse(response)["data"];

      if (allNominee.length > 0) {

        // allNominee = allNominee[0];
        console.log('llkkkdskd', allNominee)

        const proofType = allNominee[0]["nominee_id_proof_type"];

        let id_proof_type;
        if (proofType === "PAN") {
          id_proof_type = 1;
        } else if (proofType === "Aadhaar") {
          id_proof_type = 2;
        } else if (proofType === "Driving License") {
          id_proof_type = 3;
        } else {
          id_proof_type = "";
        }

        setAllNominee(allNominee);

        setFullname(allNominee[0]["nominee_first_name"]);
        setPercentage(allNominee[0]["nominee_applicable"]);
        setDob(allNominee[0]["nominee_dob"]);
        setGuardianName(allNominee[0]["nominee_guardian_name"] ? allNominee[0]["nominee_guardian_name"] : "");
        setRelation(allNominee[0]["nominee_relation"]);
        setnomineeid(allNominee[0]["nominee_id"]);
        setNominee_email(allNominee[0]["nominee_email"]);
        setNominee_mobile(allNominee[0]["nominee_mobile"]);
        setNominee_address1(allNominee[0]["nominee_address1"]);
        setNominee_address2(allNominee[0]["nominee_address2"]);
        setNominee_address3(allNominee[0]["nominee_address3"]);
        setNominee_pincode(allNominee[0]["nominee_pincode"]);
        setNominee_country(allNominee[0]["nominee_country"]);
        setNominee_state(allNominee[0]["nominee_state"]);
        setNominee_city(allNominee[0]["nominee_city"]);
        setNominee_id_proof_type(id_proof_type);
        setNominee_id_proof_number(allNominee[0]["nominee_id_proof_number"]);
        // setId_proof_image(allNominee[0]["id_proof_image"] ? allNominee[0]["id_proof_image"] : null);

        const countriesArr = await getCountries(true);
        let statesArr = [];
        let citiesArr = [];
        if (allNominee[0]["nominee_country"] && allNominee[0]["nominee_state"]) {
          statesArr = await getStates(true, allNominee[0]["nominee_country"] + '');
          citiesArr = await getCities(true, allNominee[0]["nominee_state"] + '');
        }

        setSountryStateCity(prev => ({
          ...prev,
          countries: countriesArr,
          states: statesArr,
          cities: citiesArr
        }));

        setUploaded_doc_image(allNominee[0]["doc_url"] ? allNominee[0]["doc_url"] : null);
        console.log("??????????????????????????? ", allNominee[0]["doc_url"])
      }
    } catch (e) {
      dispatch({
        type: "RENDER_TOAST",
        payload: { message: "Something went Wrong...", type: "error" },
      });
    }
  };

  var load = allNominee.length;
  if (load > 0) {
    var set = Boolean(true);
  } else {
    var set = Boolean(false);
  }

  var addnominee_req = {
    nominee_first_name: fullname,
    nominee_dob: moment(dob).format("YYYY-MM-DD"),
    nominee_applicable: "100",
    nominee_guardian_name: guardianName,
    nominee_relation: relation,
    user_id: user_id,
  };


  const saveNominee = async () => {
    // if (validateForm() == false) return;
    const formData = new FormData();

    formData.append('nominee_first_name', fullname);
    formData.append('nominee_dob', dob);
    formData.append('nominee_applicable', "100");
    formData.append('nominee_relation', relation);
    formData.append('user_id', getUserId());
    formData.append('is_authenticated', "1");
    formData.append('nominee_email', nominee_email);
    formData.append('nominee_mobile', nominee_mobile);
    formData.append('nominee_address1', nominee_address1);
    formData.append('nominee_address2', nominee_address2);
    formData.append('nominee_address3', nominee_address3);
    formData.append('nominee_pincode', nominee_pincode);
    formData.append('nominee_city', nominee_city);
    formData.append('nominee_state', nominee_state);
    formData.append('nominee_country', nominee_country);
    formData.append('nominee_id_proof_type', nominee_id_proof_type);
    formData.append('nominee_id_proof_number', nominee_id_proof_number);
    formData.append('nominee_guardian_name', guardianName ? guardianName : null);
    if (nomineeid) {
      formData.append('nominee_id', nomineeid);
    }
    formData.append('no_enc_key', 'AAAA');

    if (id_proof_image) {
      formData.append('id_proof_image', id_proof_image);
    }

    try {
      const payload = {
        method: 'post',
        url: constClass.DMF_ADDNOMINEE_API_URL,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }
      console.log('payload1mmmmm', allNominee);
      const sameCheck = isDataSame()
      if (allNominee.length > 0 && !sameCheck) {
        payload.url = constClass.DMF_UPDATENOMINEE_API_URL
      }
      console.log('payload2mmmmm', payload);
      // return;

      const r = await fetchData(payload);
      console.log("RRRRRRRRRRRRRRRRRRRR ", r)
      if (r.error_code === '100') {
        dispatch({
          type: "RENDER_TOAST",
          payload: { message: r.message, type: "success" },
        });
        nomineelist();
        setShowdata(false);
        props.onNext(navDynamic.next);
      } else {
        dispatch({
          type: "RENDER_TOAST",
          payload: { message: r.message, type: "error" },
        });
      }
    } catch (e) {
      console.log('e------>', e);
    }

  };

  useEffect(() => {
    if (allNominee.length < 1) {
      setAddMore(true);
    } else {
      setAddMore(false);
    }
  }, [allNominee]);

  const fetchSms = async () => {
    var sms_api_id = "fintoo_otp";
    var otp = randomOTP.current;
    // setGeneratedSmsOTP(otp);
    // var msg = "Greetings from Fintoo! Your OTP verification code is " + otp;
    // var whatsapptext =
    //   "Greetings from Fintoo! Your OTP verification code is : " + otp;

    var urlsms = {
      mobile: userDetails.mobile,
      otp: otp,
      key: "add_nominee",
      is_direct: constClass.IS_DIRECT,
    };
    var data2 = commonEncode.encrypt(JSON.stringify(urlsms));
    var config1 = {
      method: "post",
      url: constClass.DMF_SENDSMS_API_URL,
      data: data2,
    };

    var res = await axios(config1);
    var response = commonEncode.decrypt(res.data);
  };


  const fetchMail = async () => {
    var otp = randomOTP.current;
    setGeneratedEmailOTP(otp);
    console.log(otp, "otppp")
    var urlmail = {
      userdata: {
        to: email1,
      },
      subject: "Fintoo - Verification for your new account",
      template: "otp_message_template.html",
      contextvar: { otp: otp },
    };

    var data = commonEncode.encrypt(JSON.stringify(urlmail));
    var config = {
      method: "post",
      url: constClass.DMF_SENDMAIL_API_URL,
      data: data,
    };

    var res = await axios(config);
    var response = commonEncode.decrypt(res.data);
    var rep_msg = response.data;
  };
  const getNomineeRelations = async () => {
    console.log('relation')
    try {
      console.log('relation1')
      var config = {
        method: "post",
        url: constClass.DMF_NOMINEERELATIONSHIP_LIST,
        data: {}
      };
      console.log('relation1', config)
      var res = await axios(config);
      console.log(res, 'resss')
      var responseRel = res.data;

      setNomineeRelations(responseRel.data);
    } catch (e) { }
  };
  console.log('data', nomineerelations)

  // -------------------------------------------------------------------------------------------------------------------------------------

  const onDrop = (pictureFiles, pictureDataURLs) => {
    console.log('pictureFiles', pictureFiles, 'pictureDataURLs', pictureDataURLs)
    setId_proof_image(pictureFiles[0]);
  }

  const getCountries = async (returnArr) => {
    try {
      var config = {
        method: "post",
        url: constClass.DMF_GETCOUNTRIES_API_URL,
      };
      var res = await axios(config);
      // var responseCities = res.data;

      console.log('responseCountries', res.data.data)
      if (returnArr) {
        return res.data.data;
      } else {
        setSountryStateCity(prev => ({ ...prev, countries: res.data.data }))
      }

    } catch (e) {
      console.log("catch", e);
    }
  };

  const getStates = async (returnArr, country_id) => {

    console.log('getStatesgetStates', country_id);

    if (!country_id) return [];

    let countryData = { country_id: country_id };
    try {
      var config = {
        method: "post",
        url: constClass.DMF_GETSTATES_API_URL,
        data: countryData,
      };
      var res = await axios(config);

      if (returnArr) {
        return res.data.data;
      } else {
        setSountryStateCity(prev => ({ ...prev, states: res.data.data, cities: [] }));
      }
    } catch (e) {
      console.log("catch", e);
    }
  };

  const getCities = async (returnArr, state_id) => {

    console.log('getCitiesgetCities', state_id);

    if (!state_id) return [];

    let stateData = { state_id: state_id };
    try {
      var config = {
        method: "post",
        url: constClass.DMF_GETCITIES_API_URL,
        data: stateData,
      };
      var res = await axios(config);

      if (returnArr) {
        return res.data.data;
      } else {
        setSountryStateCity(prev => ({ ...prev, cities: res.data.data }))
      }
    } catch (e) {
      console.log("catch", e);
    }
  };

  const onCountryChange = async (country_id) => {
    if (!country_id) return;
    setNominee_country(country_id);
    setNominee_state("");
    await getStates(false, country_id);
  }
  const onStateChange = async (state_id) => {
    if (!state_id) return;
    setNominee_state(state_id);
    setNominee_city("");
    await getCities(false, state_id);
  }

  useEffect(() => {
    getCountries()
  }, [])

  return (
    <>
      <ToastContainer limit={1} />
      <Row className="reverse">
        <div className="ProfileImg col-12 col-md-6">
          <div>
            <img src={Profile_1} alt="" />
          </div>
        </div>
        <div className=" col-12 col-md-6 RightPanel">
          <div className="rhl-inner">
            {showBack == true && (
              <FintooProfileBack
                title="Add Nominee"
                onClick={() => props.onPrevious(navDynamicPrev)}
              />
            )}
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Label className="LabelName pt-4" htmlFor="inputText">
                Please add your nominee details.
              </Form.Label>
              {allNominee.length < 1 && (
                <div
                  className="profile-addmore noselect"
                  onClick={() => {
                    setEditNumber(null);
                    resetForm();
                  }}
                ></div>
              )}
              <div>
                <div className="mylist-items-3 my-3 position-relative">
                  <div className="row">
                    <div className="col-12 col-md-6 profile-space-1 mainformhere">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Nominee Full Name
                      </Form.Label>
                      <Form.Control
                        autoComplete
                        placeholder="Name"
                        type="text"
                        style={{
                          height: "2.5rem",
                          borderRadius: "10px",
                        }}
                        className="NomineeName shadow-none"
                        id="inputText"
                        aria-describedby="passwordHelpBlock"
                        maxlength="40"
                        value={fullname}
                        onChange={(e) => {
                          if (
                            e.target.value === "" ||
                            /^[a-z A-Z]+$/.test(e.target.value)
                          ) {
                            setFullname(e.target.value);
                          }
                        }}
                      />
                      {"fullname" in error && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="d-block"
                        >
                          {error.fullname}
                        </Form.Control.Feedback>
                      )}
                    </div>
                    <div className="col-12 col-md-6  profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Percentage
                      </Form.Label>
                      <Form.Control
                        required
                        className="shadow-none"
                        style={{
                          borderRadius: "10px",
                          height: "2.5rem",
                          outline: "none",
                        }}
                        classname=""
                        placeholder=""
                        value="100 %"
                        onChange={(e) => setPercentage(e.target.value)}
                      ></Form.Control>
                      {"percentage" in error && (
                        <div className="invalid-feedback d-block">
                          {error.percentage}
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-6 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Relation
                      </Form.Label>
                      <Form.Select
                        required
                        aria-label="Default select example"
                        style={{
                          borderRadius: "10px",
                          height: "2.5rem",
                          outline: "none",
                        }}
                        className="NomineeName shadow-none"
                        onChange={(e) => setRelation(e.target.value)}
                        value={relation}
                      >
                        <option value="">Select</option>
                        {nomineerelations.map((v) => (
                          <option value={v.relation_name}>
                            {v.relation_name}
                          </option>
                        ))}
                      </Form.Select>
                      {"relation" in error && (
                        <div className="invalid-feedback d-block">
                          {error.relation}
                        </div>
                      )}
                    </div>
                    <div className=" col-12 col-md-6 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Date of Birth
                      </Form.Label>
                      <FormGroup controlId="date" bsSize="large">
                        <div
                          className={`dob8 nominee-calendar ${dob ? "m_selected" : "m_empty"
                            }`}
                        >
                          <FintooDatePicker
                            maxDate={new Date()}
                            monthPlaceholder="MM"
                            yearPlaceholder="YYYY"
                            dayPlaceholder="DD"
                            className={`my-dob-calendar`}
                            onChange={(v) => setDob(moment(v).format('Y-MM-D'))}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            showMonthDropdown
                            showYearDropdown
                            selected={dob ? new Date(dob) : null}
                            dateFormat="dd/MM/yyyy"
                          />
                        </div>
                      </FormGroup>
                      {"dob" in error && (
                        <div className="invalid-feedback d-block">
                          {error.dob}
                        </div>
                      )}
                    </div>
                    <>
                      {moment().diff(moment(dob), "years") < 18 && (
                        <div className="col-12 profile-space-1 col-md-6">
                          <Form.Label className="LabelName" htmlFor="inputText">
                            Parent/Guardian name
                          </Form.Label>
                          <Form.Control
                            placeholder="Name"
                            className="shadow-none"
                            required
                            type="text"
                            maxlength="40"
                            style={{
                              height: "2.5rem",
                              borderRadius: "10px",
                            }}
                            id="inputText"
                            aria-describedby="passwordHelpBlock"
                            value={guardianName}
                            onChange={(e) => {
                              if (
                                e.target.value === "" ||
                                /^[a-z A-Z]+$/.test(e.target.value)
                              ) {
                                setGuardianName(e.target.value);
                              }
                            }}
                          />
                          {"guardianName" in error && (
                            <div className="invalid-feedback d-block">
                              {error.guardianName}
                            </div>
                          )}
                        </div>
                      )}
                    </>
                    {/* --------------------------------------------------------------------------------------------------------------------------------------- */}
                    <div className="col-12 col-md-6 profile-space-1 col-md-6">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Email
                      </Form.Label>
                      <Form.Control
                        placeholder="Email"
                        className="shadow-none"
                        required
                        type="text"
                        maxlength="40"
                        style={{
                          height: "2.5rem",
                          borderRadius: "10px",
                        }}
                        id="inputText"
                        aria-describedby="passwordHelpBlock"
                        value={nominee_email}
                        onChange={(e) =>
                          setNominee_email(e.target.value)
                        }
                      />
                      {"nominee_email" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_email}
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-6 profile-space-1 col-md-6">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Mobile
                      </Form.Label>
                      <Form.Control
                        placeholder="Mobile"
                        className="shadow-none"
                        required
                        type="number"
                        maxlength="40"
                        style={{
                          height: "2.5rem",
                          borderRadius: "10px",
                        }}
                        id="inputText"
                        aria-describedby="passwordHelpBlock"
                        value={nominee_mobile}
                        onChange={(e) => setNominee_mobile(e.target.value)}
                      />
                      {"nominee_mobile" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_mobile}
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Address line 1
                      </Form.Label>
                      <Form.Control
                        autoComplete
                        placeholder="Address"
                        maxlength="40"
                        as="textarea"
                        rows={2}
                        className="NomineeName shadow-none"
                        value={nominee_address1}
                        onChange={(e) => setNominee_address1(e.target.value)}
                      />
                      {"nominee_address1" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_address1}
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Address line 2
                      </Form.Label>
                      <Form.Control
                        autoComplete
                        placeholder="Address"
                        maxlength="40"
                        as="textarea"
                        rows={2}
                        className="NomineeName shadow-none"
                        value={nominee_address2}
                        onChange={(e) => setNominee_address2(e.target.value)}
                      />
                      {"nominee_address2" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_address2}
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Address line 3
                      </Form.Label>
                      <Form.Control
                        autoComplete
                        placeholder="Address"
                        maxlength="40"
                        as="textarea"
                        rows={2}
                        className="NomineeName shadow-none"
                        value={nominee_address3}
                        onChange={(e) => setNominee_address3(e.target.value)}
                      />
                      {"nominee_address3" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_address3}
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Country
                      </Form.Label>
                      <Form.Select
                        required
                        aria-label="Default select example"
                        style={{
                          borderRadius: "10px",
                          height: "2.5rem",
                          outline: "none",
                        }}
                        className="NomineeName shadow-none"
                        onChange={(e) => onCountryChange(e.target.value)}
                        value={nominee_country}

                      >
                        <option value="">Select</option>
                        {
                          countryStateCity.countries.map(data => <option value={data.country_id}>{data.country_name}</option>)
                        }
                      </Form.Select>
                      {"nominee_country" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_country}
                        </div>
                      )}
                    </div>
                    <div className=" col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        State
                      </Form.Label>
                      <Form.Select
                        required
                        aria-label="Default select example"
                        style={{
                          borderRadius: "10px",
                          height: "2.5rem",
                          outline: "none",
                        }}
                        className="NomineeName shadow-none"
                        onChange={(e) => onStateChange(e.target.value)}
                        value={nominee_state}
                      >
                        <option value="">Select</option>
                        {
                          countryStateCity.states.map(data => <option value={data.state_id}>{data.state_name}</option>)
                        }
                      </Form.Select>
                      {"nominee_state" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_state}
                        </div>
                      )}
                    </div>
                    <div className=" col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        City
                      </Form.Label>
                      <Form.Select
                        required
                        aria-label="Default select example"
                        style={{
                          borderRadius: "10px",
                          height: "2.5rem",
                          outline: "none",
                        }}
                        className="NomineeName shadow-none"
                        onChange={(e) => setNominee_city(e.target.value)}
                        value={nominee_city}
                      >
                        <option value="">Select</option>
                        {
                          countryStateCity.cities.map(data => <option value={data.city_id}>{data.city_name}</option>)
                        }
                      </Form.Select>
                      {"nominee_city" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_city}
                        </div>
                      )}
                    </div>
                    <div className=" col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Pin code
                      </Form.Label>
                      <Form.Control
                        autoComplete
                        placeholder="Pin code"
                        type="text"
                        style={{
                          height: "2.5rem",
                          borderRadius: "10px",
                        }}
                        className="NomineeName shadow-none"
                        id="PIN"
                        maxlength="6"
                        value={nominee_pincode}
                        onChange={(e) => setNominee_pincode(e.target.value)}
                      />
                      {"nominee_pincode" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_pincode}
                        </div>
                      )}
                    </div>
                    <div className=" col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Nominee ID Type
                      </Form.Label>
                      <Form.Select
                        required
                        aria-label="Default select example"
                        style={{
                          borderRadius: "10px",
                          height: "2.5rem",
                          outline: "none",
                        }}
                        className="NomineeName shadow-none"
                        onChange={(e) => setNominee_id_proof_type(e.target.value)}
                        value={nominee_id_proof_type}
                      >
                        <option value="">Select</option>
                        <option value="1">PAN</option>
                        <option value="2">Aadhaar</option>
                        <option value="3">Driving license</option>
                      </Form.Select>
                      {"nominee_id_proof_type" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_id_proof_type}
                        </div>
                      )}
                    </div>
                    <div className=" col-12 col-md-4 profile-space-1">
                      <Form.Label className="LabelName" htmlFor="inputText">
                        Nominee ID Number
                      </Form.Label>
                      <Form.Control
                        autoComplete
                        placeholder="Nominee ID Number"
                        type="text"
                        style={{
                          height: "2.5rem",
                          borderRadius: "10px",
                        }}
                        className="NomineeName shadow-none"
                        onChange={(e) => setNominee_id_proof_number(e.target.value)}
                        value={nominee_id_proof_number}
                      />
                      {"nominee_id_proof_number" in error && (
                        <div className="invalid-feedback d-block">
                          {error.nominee_id_proof_number}
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                      <div style={{ width: uploaded_doc_image ? '50%' : '100%' }}>
                        <ImageUploader
                          withIcon={false}
                          withPreview={true}
                          buttonText='Choose image'
                          label=""
                          singleImage={true}
                          onChange={onDrop}
                          imgExtension={[".jpg", ".png"]}
                          maxFileSize={1048576}
                          fileSizeError=" file size is too big"
                          className="ImageUploaderCustomClass"
                        />
                        {"id_proof_image" in error && (
                          <div className="invalid-feedback d-block">
                            {error.id_proof_image}
                          </div>
                        )}
                      </div>
                      {
                        uploaded_doc_image &&
                        <div style={{ width: '50%' }}>
                          <div className="bank-label nomiee-label bank-data">
                            Uploaded Document
                          </div>
                          <img style={{ width: '100%' }} src={uploaded_doc_image} alt="" />
                        </div>
                      }
                    </div>
                    <div className="invalid-feedback d-block">
                      Only .jpg and .png images are allowed
                    </div>
                    {/* --------------------------------------------------------------------------------------------------------------------------------------- */}
                  </div>
                </div>
              </div>
            </Form>
            <div className="pt-4 fintoo-top-border mt-4">
              <div className={`mb-3,mx-2 ${moment().diff(moment(dob), "years") <
                18
                ? ""
                : "d-none"
                }`} style={{ fontFamily: "Red Hat Text" }}>
                <p className="mt-4">Since your nominee is a minor, please enter his/her guardian details. The guardian should not be the same as the Fintoo account holder - that’s you!</p><strong>Note:</strong> Account holder(s) cannot be a Guardian.</div>
              <FintooButton
                className={`d-block me-0 ms-auto`}
                onClick={() => {
                  console.log('mmmmm', validateForm())
                  if (validateForm() == false) { return }
                  else {
                    handleNextBtn();
                  }

                }}
                title={"Next"}
              />
            </div>
            <p>&nbsp;</p>
          </div>
        </div>
        <Modal
          backdrop="static"
          className="NomineeModal white-modal"
          centered
          show={showdata}
          onHide={() => handleClosedata()}
        >
          <div className="d-flex justify-center p-3">
            <div
              className="DeleteBank text-center pb-3 w-100"
              style={{
                borderBottom: "1px solid #eeee",
              }}
            >
              <div
                className="pt-2"
                style={{
                  fontWeight: "600",
                }}
              >
                Enter OTP
              </div>

            </div>
          </div>
          <div>
            <div>
              <div
                className="text-center"
                style={{
                  fontWeight: "500",
                  alignContent: "center"
                }}
              >
                {"          "}
                Validate
              </div>
              <div className="p-3">
                <div className="modal-whitepopup-box-item  border-top-0 text-center">
                  <p>Sent to</p>
                  <p>{email1}</p>
                  <p>{mobile1}</p>
                </div>
                <div className="d-flex justify-center align-items-center">
                  <center>
                    <OTPInput
                      value={OTP}
                      onChange={setOTP}
                      style={{
                        width: "8%",
                      }}
                      autoFocus
                      className="rounded rounded-otp"
                      OTPLength={5}
                      otpType="number"
                      disabled={false}
                    />
                  </center>
                </div>

                <div
                  style={{
                    borderBottom: "1px solid #eeee",
                  }}
                  className="text-center p-3 grey-color"
                >
                  {count == 0 && (
                    <p
                      className="pointer blue-color"
                      onClick={() => {
                        randomOTP.current =
                          Math.floor(Math.random() * 90000) + 10000;
                        startTimer();
                        fetchMail();
                        fetchSms();
                      }}
                    >
                      Resend OTP
                    </p>
                  )}

                  {count > 0 && (
                    <p>
                      Resend in &nbsp;
                      <strong>
                        {moment().startOf("day").seconds(count).format("mm:ss")}
                      </strong>
                    </p>
                  )}
                </div>
              </div>
              <div
                className="mt-3"
                style={{
                  background: "#042b62",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "#fff",
                  borderBottomLeftRadius: "1rem",
                  borderBottomRightRadius: "1rem",
                  paddingTop: "1rem",
                  paddingBottom: "1rem",
                  cursor: "pointer"
                }}
                onClick={() => {
                  if (!OTP || OTP.trim() === "") {
                    dispatch({
                      type: "RENDER_TOAST",
                      payload: { message: "Please enter the OTP", type: "error" },
                    });
                    return;
                  }
                  if (GeneratedSmsOTP != OTP && generatedemailotp != OTP) {
                    dispatch({
                      type: "RENDER_TOAST",
                      payload: { message: "INVALID OTP", type: "error" },
                    });
                    return;
                  }
                  saveNominee();
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </Modal>
      </Row>
    </>
  );
}

export default NomineeDetails;
